import { useTranslation } from 'react-i18next';

import { Container, Header, Separator } from '~/components';
import { env } from '~/constants/env';

import { DiscountProgressCard } from './DiscountProgressCard';
import { HowItWorks } from './HowItWorks';
import { InvitationCTA } from './InvitationCTA';
import { contentStyle, heroRowStyle } from './Invitations.css';
import { InvitationsCommandMenuItems } from './InvitationsCommandMenuItems';
import { SentInvitationsTable } from './SentInvitationsTable';

export const Invitations = () => {
  const { t } = useTranslation(['invitations']);

  return (
    <>
      <Header.Root>
        <Header.Content title={t('invitations:title')} />
      </Header.Root>

      <Container className={contentStyle}>
        <div className={heroRowStyle}>
          <InvitationCTA />

          <DiscountProgressCard />
        </div>

        <HowItWorks />

        <Separator />

        <SentInvitationsTable />
      </Container>

      {(env.IS_LOCAL_DEV_ENV || env.IS_STAGING_ENV) && <InvitationsCommandMenuItems />}
    </>
  );
};
